module.exports = __webpack_public_path__ + "static/media/2.b10894a6.jpg";